module.exports = 192512